module.exports = "attribute vec3 position;\nattribute vec3 offset;\nvarying vec2 uv;\n\nprecision highp float;\n\nvoid main(){\n    uv = vec2(0.5)+(position.xy)*0.5;\n\n    \n    gl_Position = vec4(position, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/shaders/boundy.vertex
// module id = 312
// module chunks = 0